import { HydratedRouter } from "react-router/dom";
import { hydrateRoot } from "react-dom/client";
import { startTransition } from "react";

if (process.env.NODE_ENV === "production" && process.env.SENTRY_DSN) {
  void import("./lib/monitoring.client.tsx").then(({ init }) => init());
}

startTransition(() => {
  hydrateRoot(document, <HydratedRouter />);
});
